import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';

const serviceAreas = [
  { name: 'Calgary', primary: true },
  { name: 'Airdrie' },
  { name: 'Chestermere' },
  { name: 'Cochrane' },
  { name: 'Okotoks' },
  { name: 'High River' },
  { name: 'Rocky View County' },
];

export const ServiceArea = () => {
  return (
    <section data-testid="service-area-section" className="py-24 bg-white relative overflow-hidden">
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="eyebrow mb-5">Service Area</span>
          <h2 className="font-heading font-extrabold text-4xl sm:text-5xl text-[#0F172A] mt-5 mb-4 leading-tight">
            Serving <span className="text-[#0284C7]">Calgary</span> <br className="hidden sm:block" />
            &amp; surrounding communities.
          </h2>
          <p className="text-slate-600 mb-12 text-lg max-w-2xl mx-auto">
            DNB provides plumbing, heating, and gas fitting work across Calgary and the surrounding area. Same-day availability for many service calls.
          </p>

          <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
            {serviceAreas.map((area, index) => (
              <motion.div
                key={area.name}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.05 }}
                data-testid={`service-area-${index}`}
                className={`inline-flex items-center gap-2 px-5 py-3 rounded-full font-semibold transition-all ${
                  area.primary
                    ? 'bg-gradient-to-r from-[#38BDF8] to-[#0284C7] text-white shadow-lg shadow-slate-300/40'
                    : 'bg-white text-[#0F172A] border border-slate-300 hover:border-[#0284C7] hover:shadow-md hover:shadow-slate-200'
                }`}
              >
                <MapPin className={`w-4 h-4 ${area.primary ? 'text-white' : 'text-[#0284C7]'}`} />
                <span>{area.name}</span>
              </motion.div>
            ))}
          </div>

          <p className="text-slate-500 text-sm mt-10">
            Outside this list? Give us a call &mdash; we&rsquo;ll let you know if we can help.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ServiceArea;
